import React, { useState, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import apiService from '../Common/Configurations/APIService';
import config from '../Common/Configurations/APIConfig';
import WebsiteRenderer from '../template-library/WebsiteRenderer';
import '../template-library/global-styles.css'; // Don't forget to import your global override styles

// --- THIS HELPER FUNCTION IS THE KEY ---
// It converts the StyleJson from the DB into CSS variables for the browser.
const generateCssVariables = (config) => {
    const variables = {};
    if (!config) return variables;

    // Map your StyleJson properties to CSS variable names
    if (config.primary) variables['--primary'] = config.primary;
    if (config.secondary) variables['--secondary'] = config.secondary;
    
    if (config.topBar) {
        if (config.topBar.bgColor) variables['--topbar-bg-color'] = config.topBar.bgColor;
        if (config.topBar.textColor) variables['--topbar-text-color'] = config.topBar.textColor;
    }
    if (config.header) {
        if (config.header.bgColor) variables['--header-bg-color'] = config.header.bgColor;
        if (config.header.textColor) variables['--header-text-color'] = config.header.textColor;
    }
    if (config.hero) {
        if (config.hero.overlayColor) variables['--hero-overlay-color'] = config.hero.overlayColor;
        if (config.hero.subtitleColor) variables['--hero-subtitle-color'] = config.hero.subtitleColor;
    }
     if (config.footer) {
        if (config.footer.bgColor) variables['--footer-bg-color'] = config.footer.bgColor;
        if (config.footer.textColor) variables['--footer-text-color'] = config.footer.textColor;
        if (config.footer.linkColor) variables['--footer-link-color'] = config.footer.linkColor;
    }
    
    return variables;
};


function WebsiteTemplatePreviewPage() {
    const { templateId } = useParams(); 
    const [layout, setLayout] = useState(null);
    const [styleConfig, setStyleConfig] = useState(null); // <-- NEW: State for the style object
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!templateId) return;

        const fetchPreviewData = async () => {
            try {
                // Call the updated backend endpoint
                const data = await apiService.getById(config.GETTEMPLATEPREVIEWDATA, templateId);
                console.log('Fetched template preview data:', data);

                if (!data || !data.layoutJson || !data.styleJson) {
                    throw new Error("API response is missing required data.");
                }

                // We no longer need to inject a <link> tag for a static CSS file.
                
                // Save the parsed JSON data to state
                setLayout(JSON.parse(data.layoutJson));
                setStyleConfig(JSON.parse(data.styleJson));
                
            } catch (err) {
                setError(err.message || 'Failed to load template preview.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchPreviewData();
    }, [templateId]);

    // This converts the styleConfig state into a style object with CSS variables.
    const cssVariables = useMemo(() => {
        return styleConfig ? generateCssVariables(styleConfig) : {};
    }, [styleConfig]);

    if (loading) return <div><h4>Loading Preview...</h4></div>;
    if (error) return <div><h1>{error}</h1></div>;
    if (!layout) return null;

    return (
        // Apply the CSS variables to a wrapper div.
        // All components inside will now inherit these styles.
        <div style={cssVariables}>
            <WebsiteRenderer 
                layout={layout} 
                branding={{}} // Branding is separate and not needed for a generic preview
            />
        </div>
    );
}

export default WebsiteTemplatePreviewPage;